<template>
    <div
        :open="open"
        @mouseenter="open = true"
        @mouseleave="open = false"
        class="fab"
    >
        <div class="fab-inner">
            <slot />
        </div>

        <rkm-fab-item
            :color="color"
            :icon="icon"
            @click="$emit('click', $event)"
        />
    </div>
</template>

<script>
export default {
    data: () => ({
        open: false,
    }),
    props: {
        color: { type: String, default: '' },
        icon: { type: String, default: 'plus' },
    },
}
</script>

<style scoped>
.fab-inner {
    position: absolute;
    top: -57px;
    transform: translateY(-100%) translateX(-0%);
    right: 0;
    white-space: nowrap;
}

.fab:not([open]) .fab-inner {
    display: none;
}

div > .fab  + .fab{
    margin-left: 0.75rem;
}
</style>
